import { render, staticRenderFns } from "./CargarResultado.vue?vue&type=template&id=fb1e74b6&scoped=true"
import script from "./CargarResultado.vue?vue&type=script&lang=ts"
export * from "./CargarResultado.vue?vue&type=script&lang=ts"
import style0 from "./CargarResultado.vue?vue&type=style&index=0&id=fb1e74b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1e74b6",
  null
  
)

export default component.exports